import { useNavigate } from 'react-router-dom'
import { useSearchModal } from '@/context/SearchModalContext'
import { useAppDispatch } from '@/store/hooks'
import { setPlayGame } from '@/store/slices/casinoSlice'
import { cn } from '@/lib/utils'
import { RandomDiceIcon } from './icons'
import type { CasinoGame } from '@/types/casino'

interface RandomGameCardProps {
	games: CasinoGame[]
	className?: string
}

export function RandomGameCard({ games, className }: RandomGameCardProps) {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const { close } = useSearchModal()

	const handleClick = () => {
		if (games.length === 0) {
			return
		}

		const game = games[Math.floor(Math.random() * games.length)]
		dispatch(setPlayGame(game))
		close()
		navigate(`/casino/play/${game.id}`, { state: { game } })
	}

	return (
		<button
			type='button'
			onClick={handleClick}
			disabled={games.length === 0}
			className={cn('group relative h-[200px] w-[150px] shrink-0 text-white transition hover:brightness-110', 'disabled:cursor-not-allowed disabled:opacity-60', className)}
			aria-label='Play a random game'
		>
			<span
				className={cn(
					'absolute inset-0 flex flex-col items-center justify-center gap-3 overflow-hidden rounded-2xl px-3 pb-4 pt-5',
					'bg-[linear-gradient(180deg,#9100FF_0%,#FF007A_100%)]',
					'[clip-path:polygon(0%_0%,100%_0%,100%_100%,75%_100%,65%_95%,35%_95%,25%_100%,0%_100%)]',
				)}
			>
				<RandomDiceIcon className='h-[90px] w-[90px] object-contain transition group-hover:scale-105' />
				<span className='text-center text-base font-bold leading-tight tracking-[-0.24px]'>
					Random
					<br />
					Game
				</span>
			</span>

			<span
				className='pointer-events-none absolute bottom-0 left-1/2 z-10 h-1 w-8 -translate-x-1/2 rounded-full bg-border transition-[width,background-color,box-shadow] duration-200 ease-in-out group-hover:w-10 group-hover:bg-primary group-hover:shadow-[0_0_6px_2px_hsl(var(--primary)/0.55)]'
				aria-hidden
			/>
		</button>
	)
}
